<template>
    <BCard>
      <BRow>
        <BCol cols="12"> 
          <h4 class="mb-2">{{$t('General data')}}</h4> 
        </BCol> 
      </BRow>
      <BRow>  
        <BCol cols="12" xl="6" >
          <table class="mt-2 mt-xl-0 w-100">
            <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="student.full_name" />
            <ViewData vsIcon="UserIcon" vsLabel="DNI" :vsValue="student.dni" />
            <ViewData vsIcon="UserCheckIcon" vsLabel="Status" :vsValue="student.status" vsCheckbox />
            <ViewData vsIcon="SmartphoneIcon" vsLabel="Phone" vsPhone :vsValue="student.phone" />
            
            <ViewData vsIcon="PhoneIcon" vsLabel="Phone 2" :vsValue="student.phone2" />
            <ViewData vsIcon="ShoppingCartIcon" vsLabel="Accept SMS notifications" :vsValue="student.notif_sms" vsCheckbox />
            <ViewData vsIcon="ShoppingCartIcon" vsLabel="Accept email notifications" :vsValue="student.notif_email" vsCheckbox />
            <ViewData vsIcon="DollarSignIcon" vsLabel="Cuenta bancaria" :vsValue="student.iban ? student.iban : '-'" />
            <ViewData vsIcon="DollarSignIcon" vsLabel="SWIFT/BIC" :vsValue="student.swift_bic ? student.swift_bic : '-'" />
            
          </table>
        </BCol>
        
        <BCol cols="12" xl="6" >
          <table class="mt-2 mt-xl-0 w-100">
            <ViewData vsIcon="CompassIcon" vsLabel="Address" :vsValue="student.address" />
            <ViewData vsIcon="CompassIcon" vsLabel="Postal code" :vsValue="student.postal_code" />
            <ViewData vsIcon="HomeIcon" vsLabel="Town" :vsValue="student.city" />
            <ViewData vsIcon="HomeIcon" vsLabel="Province" :vsValue="student.province.name" />
            <ViewData vsIcon="GlobeIcon" vsLabel="Country" :vsValue="student.country.name" />
            <ViewData vsIcon="FolderIcon" vsLabel="Nº colegiado/a" :vsValue="student.collegiate_member_number" />
            <ViewData vsIcon="UserCheckIcon" vsLabel="Start date" :vsValue="formatDate(student.start_date)" />
            <ViewData vsIcon="UserXIcon" vsLabel="End date" :vsValue="student.end_date ? formatDate(student.end_date): ''" />
            <ViewData vsIcon="UserPlusIcon" vsLabel="Cuenta de facturación" :vsValue="student.account_id ? student.account.billing_name : '-'" />
            <ViewData vsIcon="CreditCardIcon" vsLabel="Método de pago" :vsValue="student.payment_method ? student.payment_method.name : '-'" />

          </table>
        </BCol>
  
      </BRow>
      <hr>
      <BRow>
        <BCol cols="12">
          <div class="col-12 mb-1 title p-0 font-weight-bold">
              <FeatherIcon icon="InfoIcon" class="mr-75" />
              <span>{{ $t('Observations') }}</span>
          </div>
          <div class="col-12 p-0"> 
            <span v-if="student.observations">{{ student.observations }}</span>
            <span v-else class="text-muted"><small>Sin observaciones</small></span>
          </div>
        </BCol>
      </BRow>
    </BCard>
  </template>
  
<script>
import { BCard, BButton, BAvatar, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import { inject } from '@vue/composition-api'
import ViewData from '@/components/ViewData.vue'
import dateUtils from '@/hooks/dateUtils'

  
export default {
  components: { BCard, BButton, BRow, BCol, BAvatar, BFormCheckbox, ViewData },
  setup() {
    const student = inject('student')
    const { formatDate } = dateUtils()

    return {
      student,
      formatDate
    }
  },
}
</script>
  
<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th, .title {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
  